/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_ChangeInputs */



/**
* | output |
* | --- |
* | "change" |
*
* @param {Usage_ChangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_change = /** @type {((inputs?: Usage_ChangeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_ChangeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("changement")
	if (locale === "de") return /** @type {LocalizedString} */ ("ändern")
	if (locale === "it") return /** @type {LocalizedString} */ ("modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("изменять")
	if (locale === "es") return /** @type {LocalizedString} */ ("cambiar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("改变")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変化")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("mudar")
	return /** @type {LocalizedString} */ ("change")
});